import View from '../Support/View/View';

export default class Popper extends View {

    static get viewName() {
        return 'popper';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        tippy(this.target ?? this.$el.firstElementChild ?? this.$el, this.options);
    }

    /**
     * @returns {string|null}
     */
    get target() {
        return this.viewData.target;
    }

    /**
     * @returns {Object}
     */
    get options() {
        return this.viewData.options;
    }
}